import "./LandingPage.css";
import { Link } from "react-router-dom";
import icon from "../../assets/icon128.png";

// const extensionUrl: string = import.meta.env.VITE_CHROME_EXTENSION_ID
//   ? `https://chromewebstore.google.com/detail/${import.meta.env.VITE_CHROME_EXTENSION_ID}`
//   : "https://chromewebstore.google.com";

export default function LandingPage() {
  document.title = "Profile Connector";
  return (
    <div className="lp-root">
      {/* Nav */}
      <nav className="lp-nav">
        <a href="#" className="lp-nav-brand">
          <img src={icon} alt="Profile Connector" className="lp-nav-logo" />
          Profile Connector
        </a>
        <div className="lp-nav-links">
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#compliance">Compliance</a>
          <Link to="/tos">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <a className="lp-nav-cta" href="https://chromewebstore.google.com/detail/profile-connector/ldmcjamejmajinlpipiamhciefciachp" target="_blank" rel="noopener noreferrer">
            Add to Chrome
          </a>
        </div>
      </nav>

      {/* Hero */}
      <section className="lp-hero">
        <div className="lp-hero-badge">
          <span>🔗</span>
          Chrome Extension
        </div>
        <h1>
          Connect your LinkedIn account to your{" "}
          <span>partner dashboard</span>{" "}
          in seconds
        </h1>
        <p className="lp-hero-sub">
          Profile Connector is the secure, one-click bridge between your LinkedIn
          profile and your partner platform — no scraping, no automation, no
          policy violations.
        </p>
        <div className="lp-hero-actions">
          <a className="lp-btn-primary" href="https://chromewebstore.google.com/detail/profile-connector/ldmcjamejmajinlpipiamhciefciachp" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.2" />
              <path d="M10 4a6 6 0 100 12A6 6 0 0010 4zm0 2a4 4 0 110 8 4 4 0 010-8z" fill="white" />
            </svg>
            Add to Chrome
          </a>
          <a href="#how-it-works" className="lp-btn-secondary">
            See how it works
          </a>
        </div>

        {/* Mockup */}
        <div className="lp-hero-img">
          <div className="lp-hero-mockup">
            <div className="lp-mockup-bar">
              <div className="lp-mockup-dot red" />
              <div className="lp-mockup-dot yellow" />
              <div className="lp-mockup-dot green" />
              <div className="lp-mockup-url">app.yourplatform.com/connect</div>
            </div>
            <div className="lp-mockup-content">
              {/* LinkedIn card */}
              <div className="lp-mockup-card">
                <div className="lp-mockup-card-title">LinkedIn Account</div>
                <div className="lp-mockup-profile">
                  <div className="lp-mockup-avatar">J</div>
                  <div>
                    <div className="lp-mockup-name">Jane Smith</div>
                    <div className="lp-mockup-role">Senior Marketing Manager</div>
                  </div>
                </div>
                <div className="lp-mockup-status">Active session detected</div>
              </div>

              {/* Arrow */}
              <div className="lp-mockup-arrow">
                <div className="lp-mockup-arrow-line" />
                <div className="lp-mockup-arrow-label">Secure connect</div>
              </div>

              {/* Dashboard card */}
              <div className="lp-mockup-card">
                <div className="lp-mockup-card-title">Partner Dashboard</div>
                <div className="lp-mockup-profile">
                  <div
                    className="lp-mockup-avatar"
                    style={{
                      background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                    }}
                  >
                    D
                  </div>
                  <div>
                    <div className="lp-mockup-name">Your Dashboard</div>
                    <div className="lp-mockup-role">Ready to connect</div>
                  </div>
                </div>
                <div
                  className="lp-mockup-status"
                  style={{ background: "#ede9fe", color: "#7c3aed" }}
                >
                  Awaiting connection
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust bar */}
      <div className="lp-trust-bar">
        <div className="lp-trust-item">
          <span className="lp-trust-icon">🔒</span>
          TLS 1.3 Encrypted
        </div>
        <div className="lp-trust-item">
          <span className="lp-trust-icon">✅</span>
          LinkedIn TOS Compliant
        </div>
        <div className="lp-trust-item">
          <span className="lp-trust-icon">🚫</span>
          No Data Scraping
        </div>
        <div className="lp-trust-item">
          <span className="lp-trust-icon">⚡</span>
          One-Click Connection
        </div>
        <div className="lp-trust-item">
          <span className="lp-trust-icon">🛡️</span>
          No Automation
        </div>
      </div>

      {/* Features */}
      <section className="lp-section" id="features">
        <div className="lp-section-label">Features</div>
        <h2 className="lp-section-title">
          Everything you need to connect accounts securely
        </h2>
        <p className="lp-section-sub">
          Built specifically for partner integrations. Simple for end users,
          powerful for platforms.
        </p>

        <div className="lp-features-grid">
          <div className="lp-feature-card">
            <div className="lp-feature-icon">🔗</div>
            <h3 className="lp-feature-title">Secure Account Linking</h3>
            <p className="lp-feature-desc">
              Connects your active LinkedIn session to your partner dashboard
              securely, using only the session token present in your browser.
              Nothing else is accessed or stored.
            </p>
          </div>
          <div className="lp-feature-card">
            <div className="lp-feature-icon">⚡</div>
            <h3 className="lp-feature-title">One-Click Setup</h3>
            <p className="lp-feature-desc">
              No complicated configuration. Install the extension, open your
              partner dashboard, and click Connect. The entire process takes
              under 30 seconds.
            </p>
          </div>
          <div className="lp-feature-card">
            <div className="lp-feature-icon">🛡️</div>
            <h3 className="lp-feature-title">Privacy First</h3>
            <p className="lp-feature-desc">
              Profile Connector does not read your messages, connections, or
              profile data. It reads only the minimum required to establish
              account identity.
            </p>
          </div>
          <div className="lp-feature-card">
            <div className="lp-feature-icon">🔄</div>
            <h3 className="lp-feature-title">Session Management</h3>
            <p className="lp-feature-desc">
              Automatically handles reconnection when your LinkedIn session
              expires, so your partner platform stays in sync without manual
              intervention.
            </p>
          </div>
          <div className="lp-feature-card">
            <div className="lp-feature-icon">🏢</div>
            <h3 className="lp-feature-title">Multi-Platform Support</h3>
            <p className="lp-feature-desc">
              Works across all whitelabel partner dashboards that support the
              Profile Connector standard — one extension, multiple platforms.
            </p>
          </div>
          <div className="lp-feature-card">
            <div className="lp-feature-icon">📋</div>
            <h3 className="lp-feature-title">Transparent Permissions</h3>
            <p className="lp-feature-desc">
              We request only the permissions necessary to read your current
              LinkedIn session. You can review exactly what we access at any
              time in the Chrome extension settings.
            </p>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="lp-how" id="how-it-works">
        <div className="lp-how-inner">
          <div className="lp-how-header">
            <div className="lp-section-label">How it works</div>
            <h2 className="lp-section-title">Up and running in 4 simple steps</h2>
            <p className="lp-section-sub" style={{ margin: "0 auto" }}>
              No technical knowledge required. If you can log into LinkedIn and
              install a Chrome extension, you're already done.
            </p>
          </div>

          <div className="lp-steps">
            <div className="lp-step">
              <div className="lp-step-num">1</div>
              <h3 className="lp-step-title">Install the extension</h3>
              <p className="lp-step-desc">
                Add Profile Connector to Google Chrome from the Chrome Web Store.
                It takes one click and requires no account.
              </p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">2</div>
              <h3 className="lp-step-title">Log in to LinkedIn</h3>
              <p className="lp-step-desc">
                Open LinkedIn in Chrome and make sure you are logged into the
                account you want to connect to your partner dashboard.
              </p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">3</div>
              <h3 className="lp-step-title">Click "Connect via Extension"</h3>
              <p className="lp-step-desc">
                In your partner dashboard's connection page, click the Connect via
                Extension button. Profile Connector handles the rest instantly.
              </p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">4</div>
              <h3 className="lp-step-title">You're connected</h3>
              <p className="lp-step-desc">
                Your LinkedIn account is now linked to your partner dashboard.
                You'll see a confirmation and can start using the platform
                immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance */}
      <section className="lp-compliance" id="compliance">
        <div className="lp-compliance-inner">
          <div>
            <div className="lp-compliance-label">Compliance & Safety</div>
            <h2 className="lp-compliance-title">
              Built to respect LinkedIn's Terms of Service
            </h2>
            <p className="lp-compliance-sub">
              We designed Profile Connector from the ground up to work within
              LinkedIn's rules — not around them. Your account stays safe.
            </p>
            <ul className="lp-compliance-list">
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>No scraping.</strong> We never extract profile data,
                  connections, posts, or any content from LinkedIn pages.
                </span>
              </li>
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>No automation.</strong> We do not send messages, connection
                  requests, or perform any actions on your behalf.
                </span>
              </li>
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>No bots.</strong> Profile Connector is not a bot, crawler,
                  or spider. It is a passive session bridge only.
                </span>
              </li>
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>User initiated.</strong> Every connection action is
                  explicitly triggered by the user — never automatic or background.
                </span>
              </li>
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>Minimal permissions.</strong> The extension requests only
                  what is needed to read the current session — nothing more.
                </span>
              </li>
              <li>
                <div className="lp-check">✓</div>
                <span>
                  <strong>Disconnect anytime.</strong> You can disconnect your
                  LinkedIn account at any time through your partner dashboard or
                  directly through LinkedIn.
                </span>
              </li>
            </ul>
          </div>

          <div className="lp-compliance-badges">
            <div className="lp-compliance-badge">
              <div className="lp-compliance-badge-icon">🔐</div>
              <div>
                <div className="lp-compliance-badge-title">
                  Session-only access
                </div>
                <div className="lp-compliance-badge-desc">
                  We only access your existing LinkedIn browser session — the same
                  session you created by logging in yourself. No passwords or
                  credentials are ever requested or stored.
                </div>
              </div>
            </div>
            <div className="lp-compliance-badge">
              <div className="lp-compliance-badge-icon">🌐</div>
              <div>
                <div className="lp-compliance-badge-title">
                  Transparent operation
                </div>
                <div className="lp-compliance-badge-desc">
                  All data transfers happen over TLS 1.3 encrypted connections
                  between your browser, LinkedIn, and your partner platform.
                  Nothing is sent to third-party servers.
                </div>
              </div>
            </div>
            <div className="lp-compliance-badge">
              <div className="lp-compliance-badge-icon">❌</div>
              <div>
                <div className="lp-compliance-badge-title">
                  No background activity
                </div>
                <div className="lp-compliance-badge-desc">
                  Profile Connector only activates when you explicitly use the
                  Connect button in your partner dashboard. It performs no
                  background tasks.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-cta-inner">
          <h2>Ready to connect your LinkedIn account?</h2>
          <p>
            Install Profile Connector in seconds and link your account to your
            partner dashboard with a single click.
          </p>
          <div className="lp-hero-actions">
            <a className="lp-btn-primary" href="https://chromewebstore.google.com/detail/profile-connector/ldmcjamejmajinlpipiamhciefciachp" target="_blank" rel="noopener noreferrer">
              Add to Chrome
            </a>
            <Link to="/tos" className="lp-btn-secondary">
              Read our Terms of Service
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-top">
            <div>
              <a href="#" className="lp-footer-brand">
                <img src={icon} alt="Profile Connector" className="lp-nav-logo" style={{ width: 28, height: 28 }} />
                Profile Connector
              </a>
              <p className="lp-footer-brand-desc">
                The secure, compliant way to connect your LinkedIn account to
                partner platforms.
              </p>
            </div>
            <div className="lp-footer-links">
              <div className="lp-footer-col">
                <h4>Product</h4>
                <ul>
                  <li>
                    <a href="#features">Features</a>
                  </li>
                  <li>
                    <a href="#how-it-works">How it works</a>
                  </li>
                  <li>
                    <a href="#compliance">Compliance</a>
                  </li>
                </ul>
              </div>
              <div className="lp-footer-col">
                <h4>Legal</h4>
                <ul>
                  <li>
                    <Link to="/tos">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="lp-footer-bottom">
            <span>
              © {new Date().getFullYear()} Profile Connector. All rights reserved.
            </span>
            <div style={{ display: "flex", gap: "24px" }}>
              <Link to="/tos">Terms of Service</Link>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
